import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal';
import Form from '../../../../assets/Style/Form.module.css';
import cl from './DocIssuer.module.css'
import Id from "../../../../assets/Icon/Id";  
import User from "../../../../assets/Icon/User";  
 
const DocIssuerModal = ({ isOpen, open, onClose, onSave, car }) => {

  const [personalDetails, setPersonalDetails] = useState({
    firstname: '',
    lastname: '',
    personal_number: ''
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setPersonalDetails({
      ...personalDetails,
      [name]: value
    });
  };

  const handleSave = () => {
    onSave(personalDetails);
    onClose();
  };

  useEffect(() => {
    const parts = car.doc_issuer ? car.doc_issuer.split(' ') : [];
    while (parts.length < 3) {
      parts.push('');
    }
    setPersonalDetails({
      firstname: parts[0],
      lastname: parts[1],
      personal_number: parts[2]
    });
  }, [car.doc_issuer]);


  return (
    <div>

      <div>

        {(personalDetails.firstname == "" || personalDetails.lastname == "" ?
          <div style={{ cursor: 'pointer' }} onClick={() => { open(true) }} > --- </div>
          :
          <div style={{ cursor: 'pointer' }} onClick={() => { open(true) }} > {personalDetails.firstname + " " + personalDetails.lastname} </div>
        )}

      </div>

      <Modal isOpen={isOpen} onClose={onClose}>

      <div className={cl.modalHead} >
          <h3> საბუთის მიმღები </h3>
      </div>

        <div className={Form.modalContent}>
 
          <div className={cl.inp2col}>

            <div className={cl.groupInput}>
                <div className={cl.groupInputIcon}>
                    <input type="textS" className={  cl.input  } placeholder="სახელი" name="firstname" value={personalDetails.firstname} onChange={handleChange} autoComplete="off" />
                    <div className={cl.crmIcon}><User /></div>
                </div>
            </div>

            <div className={cl.groupInput}>
                <div className={cl.groupInputIcon}>
                    <input type="textS" className={ cl.input } placeholder="გვარი" name="lastname" value={personalDetails.lastname} onChange={handleChange} autoComplete="off" />
                    <div className={cl.crmIcon}><User /></div>
                </div>
            </div>

          </div>


        <div className={cl.groupInput}>
        <div className={cl.groupInputIcon}>
            <input type="textS" className={ cl.input } placeholder="პირადი ნომერი" name="personal_number" value={personalDetails.personal_number} onChange={handleChange} autoComplete="off" />
            <div className={cl.crmIcon}><Id /></div>
        </div>
       
        </div>

 
          <button onClick={handleSave} className={Form.btnPrimary}>
            შენახვა
          </button>



        </div>
      </Modal>

    </div>
  );
};

export default DocIssuerModal;
